import { watch, ref, onUnmounted } from 'vue'
import { useFormStore } from '@/stores/form'
import apiHelperService from '@/services'
import { DateTime } from 'luxon'
import client_lookups from '@/assets/json/clientLookups.json'

const dateOfBirthWatch = () => {
  const birthDateWatch = ref()
  const formStore = useFormStore()
  const {
    ServiceTransactions: { newBornPayFines }
  } = client_lookups
  birthDateWatch.value = watch(
    () => formStore.form.values.dateOfBirth,
    async (newVal) => {
      if (newVal) {
        const calculateFinesParams = {
          serviceTransactionId: newBornPayFines,
          dateOfBirth: DateTime.fromFormat(newVal, 'dd/MM/yyyy').toFormat('yyyy/MM/dd').toString(),
          administrativeRegionId: 1
        }
        const cachedData = await apiHelperService.post(
          '/api/fines/draft/calculateFines',
          calculateFinesParams
        )
        if (cachedData) {
          const { finesAmount = '', overstayDays = '' } = cachedData || {}
          formStore.form.setValues({
            totalViolationAmount: finesAmount,
            totalNumberOfViolationDays: overstayDays
          })
        }
        inferenceReportTimeSetFun(newVal)
      }
    }
  )
  onUnmounted(() => {
    birthDateWatch.value && birthDateWatch.value()
  })
}

const inferenceReportTimeSetFun = (t) => {
  const formStore = useFormStore()
  let _now = new Date()
  var dateOfBirth = new Date(t)
  var violationDate = new Date(dateOfBirth.setDate(dateOfBirth.getDate() + 89 + 119))
  formStore.extraMap = {
    ...formStore.extraMap,
    violationStartDate: violationDate,
    applicationDate: DateTime.fromJSDate(_now).toFormat("yyyy-MM-dd'T'HH:mm:ss") || '',
    showQuestionnaireQuestionThree: true
  }
  if (violationDate > _now) {
    formStore.extraMap.showQuestionnaireQuestionThree = false
  }
}
export default function () {
  return {
    dateOfBirthWatch
  }
}
